"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOCUS_AUTO = exports.FOCUS_ALLOW = exports.FOCUS_DISABLED = exports.FOCUS_GROUP = void 0;
exports.FOCUS_GROUP = 'data-focus-lock';
exports.FOCUS_DISABLED = 'data-focus-lock-disabled';
exports.FOCUS_ALLOW = 'data-no-focus-lock';
exports.FOCUS_AUTO = 'data-autofocus-inside';
